import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { JobsService }      from './transaction-center.jobs.service';
import { JobStatus }        from './transaction-center.jobs.status.filter.ajs';
import { JobStatusBooking } from './transaction-center.jobs.status-booking.filter.ajs';

angular.module('app-lite.transaction-center.jobs', [])
  .filter('jobStatus',        JobStatus)
  .filter('jobStatusBooking', JobStatusBooking)

  .service('jobsApi', downgradeInjectable(JobsService));
